import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserBookings, UserProfile, UserBenefits } from '../userImports';
// import UserBookings from '../userBookings/UserBookings';
// import UserProfile from '../userProfile/UserProfile';
import Loading from '../../../common/Loading';
import { useAuth } from '../../../../context/contexts';
import './UserDashboard.css';

const UserDashboard = () => {
  const navigate = useNavigate();
  const [activeFeature, setActiveFeature] = useState('bookings');
  const { currentUser, userFirstName, userRole, loading } = useAuth();

  useEffect(() => {
    if (!currentUser) {
      navigate('/signin');
      return;
    }

    if (userRole !== 'user') {
      navigate('/admin');
    }
    navigate('/user');
  }, [currentUser, userRole, navigate]);

  if (loading) {
    return <Loading />;
  }

  if (!currentUser || userRole !== 'user') {
    return null;
  }

  const renderFeature = () => {
    switch (activeFeature) {
      case 'bookings':
        return <UserBookings />;
      case 'profile':
        return <UserProfile />;
      case 'my-benefits':
        return <UserBenefits />;
      default:
        return <UserBookings />;
    }
  }


  return (
    <div className="user-dashboard">
      <div className="user-dashboard__sidebar">
        <div className="user-dashboard__logo">
          <h2>My Account</h2>
        </div>
        <nav className="user-dashboard__nav">
          <button
            className={`user-dashboard__nav-item ${activeFeature === 'bookings' ? 'active' : ''}`} onClick={() => setActiveFeature('bookings')}
            >
              <span className="nav-icon">📅</span>
              Bookings
            </button>
            <button
              className={`user-dashboard__nav-item ${activeFeature === 'my-benefits' ? 'active' : ''}`}
              onClick={() => setActiveFeature('')}
              // onClick={() => setActiveFeature('my-benefits')}
            >
              <span className="nav-icon">🎁</span>
              Benefits
            </button>
            <button
              className={`user-dashboard__nav-item ${activeFeature === 'profile' ? 'active' : ''}`}
              onClick={() => setActiveFeature('profile')}
            >
              <span className="nav-icon">👤</span>
              Profile
            </button>
        </nav>
      </div>

      <div className="user-dashboard__main">
        <div className="user-dashboard__header">
          <h1>Welcome, {userFirstName}</h1>
        </div>
        <div className="user-dashboard__content">
          {renderFeature()}
        </div>
      </div>
    </div>
  );
};

export default UserDashboard; 